const transformModelToProps = <T extends { model?: any; cqPath?: string }>(
	originalProps?: T,
	itemsListKey?: keyof T['model'],
) => {
	if (!originalProps?.model || !itemsListKey) return originalProps;

	const { model, cqPath = '', ...rest } = originalProps;

	const {
		cqItemsOrder = [],
		[itemsListKey]: itemsList = [],
		cqType = '',
		':path': path = cqPath,
		id = '',
		...otherModelProps
	} = model;

	const finalItemsOrder = cqItemsOrder.length
		? cqItemsOrder
		: model[':itemsOrder'] || [];

	const cqItems: Record<string, any> = {};
	finalItemsOrder.forEach((key: string, index: number) => {
		if (!cqItems[key] && itemsList[index]) {
			cqItems[key] = itemsList[index];
		}
	});

	return {
		...rest,
		model: {
			...otherModelProps,
			cqItemsOrder: finalItemsOrder,
			cqType,
			cqItems,
			id,
			':path': path,
		},
		cqPath: path,
	};
};

export default transformModelToProps;
